import Container from "react-bootstrap/Container";
import Nav from "react-bootstrap/Nav";
import Navbar from "react-bootstrap/Navbar";
import NavDropdown from "react-bootstrap/NavDropdown";
import Logo from "./logo2.png";
import "./navb.css";
function Navb() {
  return (
    <Navbar collapseOnSelect expand="lg" className=" data-bs-theme-light">
      {/* <Container> */}
      <Navbar.Brand href="/">
        <img className="logo" src={Logo} alt="Logo" />
      </Navbar.Brand>
      <Navbar.Toggle aria-controls="responsive-navbar-nav" />
      <Navbar.Collapse id="responsive-navbar-nav">
        <Nav className="ms-auto">
          <Nav.Link className="NavLinkButton" href="/">
            Home
          </Nav.Link>
          <NavDropdown
            title="Products"
            className="NavLinkButton"
            id="basic-nav-dropdown"
          >
            <NavDropdown.Item href="/aata">NANDI Chakki Aata</NavDropdown.Item>
            <NavDropdown.Item href="/maida">NANDI Maida</NavDropdown.Item>
            <NavDropdown.Item href="/sooji">NANDI Sooji</NavDropdown.Item>
            <NavDropdown.Item href="/dalia">NANDI Dalia</NavDropdown.Item>
            <NavDropdown.Item href="/besan">NANDI Besan</NavDropdown.Item>
            <NavDropdown.Item href="/salt">NANDI Pink Rock Salt</NavDropdown.Item>
            <NavDropdown.Item href="/pickles">NANDI Pickles</NavDropdown.Item>
            <NavDropdown.Item href="/spices">NANDI Spices</NavDropdown.Item>
          </NavDropdown>
          <Nav.Link className="NavLinkButton" href="/recipes">
            Recipies
          </Nav.Link>
          {/* <NavDropdown
            title="Recipies"
            className="NavLinkButton"
            id="basic-nav-dropdown"
            // href="/recipes/mix"
          >
            <NavDropdown.Item href="/recipes/mixvegparatha">
              Mixvegparatha
            </NavDropdown.Item>
            <NavDropdown.Item href="/recipes/besanburfi">
              Besanburfi
            </NavDropdown.Item>
            <NavDropdown.Item href="/recipes/daliakhichadi">
              Daliakhichadi
            </NavDropdown.Item>
            <NavDropdown.Item href="/recipes/maidavegpizzacones">
              Maidavegpizzacones
            </NavDropdown.Item>
            <NavDropdown.Item href="/recipes/wholeattavegmomos">
              Wholeattavegmomos
            </NavDropdown.Item>
            <NavDropdown.Item href="/recipes/wholeattacookies">
              Wholeattacookies
            </NavDropdown.Item>
            <NavDropdown.Item href="/recipes/soojidhokla">
              Soojidhokla
            </NavDropdown.Item>
            <NavDropdown.Item href="/recipes/sojivegcheela">
              Sojivegcheela
            </NavDropdown.Item>
            <NavDropdown.Item href="/recipes/besankadhirice">
              Besankadhirice
            </NavDropdown.Item>
            <NavDropdown.Item href="/recipes/daliasalad">
              Daliasalad
            </NavDropdown.Item>
            <NavDropdown.Item href="/recipes/nandisabjimasala">
              Nandisabjimasala
            </NavDropdown.Item>
            
          </NavDropdown> */}
          <Nav.Link className="NavLinkButton" href="/whatwedo">
            Company
          </Nav.Link>
          <Nav.Link className="NavLinkButton" href="/contactus">
            Contact Us
          </Nav.Link>

          {/* <Nav.Link eventKey={2} href="#memes">
              Dank memes
            </Nav.Link> */}
        </Nav>
      </Navbar.Collapse>
      {/* </Container> */}
    </Navbar>
  );
}

export default Navb;
